export const getMaxAndMinForDataPointModal = (openDataName, data) => {
  switch (openDataName) {
    case "downPayment":
      return { max: data.price?.toString(), min: 0 };
    default:
      return { max: undefined, min: undefined };
  }
};
